import { createStructuredSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { selectAccountID, selectNavBarData, selectCsrBusinessFunction } from '../../selectors/globalSelectors';
import { selectAccountRole } from '../Messaging/selectors';
import { selectAccountDocuments } from '../DocumentCentre/Pages/selectors';
import moment from 'moment';
import { isGeminiUser } from '../../utils/sessionUtil';
import { isEqual,isEmpty } from 'lodash';


/** Custom selector */

 const createDeepEqualSelector = createSelectorCreator(
    defaultMemoize,
    isEqual
)

/** Custom selector */

/**------------------ Local selectors ------------------------ */

export const getMyAccountStates = (data) => (data.myAccount);

export const getMyAccountData = (data) => {
    const { accountData } = getMyAccountStates(data);
    return accountData;
}

export const getProfileData = data => {
  const { profileData } = getMyAccountStates(data);
  return profileData;
};

export const getLegacyData = data => {
    const  { accountData }  = getMyAccountStates(data);
    return accountData.data;
  };

export const  isShow504Error  = (state)=>{
    const {show504Error} = getMyAccountData(state);
    return show504Error;
}

export const getAccessKeyData = (state)=>{
    const {accessKeyData}  = getMyAccountStates(state)
    return accessKeyData;
}


export const getAccountAdvisors = (state) => {
    const { data } = getMyAccountData(state);
    return data.accountAdvisors;
}

export const getPrimaryContacts = (state) => {
    const { data } = getMyAccountData(state);
    return data.primaryAccountContact;
}

export const getAuthorization = (state) => {
    const { data } = getMyAccountData(state);
    return data.authorization;
}

export const getFundNameAndAccountName = (state) => {
    const { data } = getMyAccountData(state);
    const { fundName, fundNumber } = data;
    return {
        fundName,
        fundNumber
    }
}

export const getDataFromProfile  = state => {
     const  {data} = getProfileData(state);
     return data;
}

export const getLegacyDataFromAccount  = state => {
    const  {legacy} = getLegacyData(state);
    return legacy;
}

export const modifyTableData = (_,ownProps)=>{
    const {TableData} = ownProps;
    return TableData;
}

 export const selectChangeDefault = (state)=>{
    const {changeDefault} = getMyAccountStates(state);
    return changeDefault;
}

export const tableTransform = (TableData = [])=>{
    return  TableData.map((obj,index)=>{
 
        return {
            ...obj,
            key:index,
            dateOp : obj.dateOpened ? moment(moment.tz(parseInt(obj.dateOpened), "America/New_York")).format("MM/DD/YYYY"): '--' ,
            bal : "$" +
            Number(obj.balance).toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            )
        }
    
        })
        
}

export const selectModifyTableData = createDeepEqualSelector(modifyTableData,tableTransform);



/**---------------------- Local selectors end ----------------------*/


/**---------------------- My Account selectors exports ----------------------*/

export const selectGetAccessKey = (state)=>{
    const {accessKey} = getAccessKeyData(state);
    return accessKey
}

export const selectValidTill = (state)=>{
    const {validTill} = getAccessKeyData(state);
    return validTill;
}
export const selectIsLoadingProfile = state => {
    const { isLoading } = getProfileData(state)
    return isLoading
};
export const selectGetData = state => {
    const { data } = getProfileData(state);
    return data;
  };

export const selectEmailInfo = createDeepEqualSelector(getDataFromProfile,(profileData)=>{
    if (isEmpty(profileData)) return;
    const emailInfo = profileData && profileData.profileSummary.email && profileData.profileSummary.email.find(e => e.primary === 1);
    return emailInfo
})

export const selectLegacyData = createDeepEqualSelector(getLegacyDataFromAccount,(legacyData)=>{
    if (isEmpty(legacyData)) return;
      let legacyModifiedData = {};
      let bestowLegacyVal = {};
      let endowLegacyVal = {};
      let otherLegacyVal = {};
    bestowLegacyVal.appoint = legacyData.legacyOptions.find((value) => {
         return value.optionId === 1 && value.selected === true;
       });
        if(bestowLegacyVal.appoint){
            bestowLegacyVal.appoint.successorAdvisor = bestowLegacyVal.appoint.successorAdvisor && bestowLegacyVal.appoint.successorAdvisor.filter((item) =>{
            return item.selected === true;
            } );
            if(!bestowLegacyVal.appoint.successorAdvisor){
                bestowLegacyVal.appoint.successorAdvisor = [];
            }
        }
    bestowLegacyVal.create = legacyData.legacyOptions.find((value) => {
        return value.optionId === 2 && value.selected === true;
      });
      if(bestowLegacyVal.create){
        bestowLegacyVal.create.successorAdvisor = bestowLegacyVal.create.successorAdvisor && bestowLegacyVal.create.successorAdvisor.filter((item) =>{
        return item.selected === true;
        } );
        if(!bestowLegacyVal.create.successorAdvisor){
            bestowLegacyVal.create.successorAdvisor = [];
        }
    }
    endowLegacyVal.endow = legacyData.legacyOptions.find((value) => {
        return value.optionId === 3 && value.selected === true;
      });
    endowLegacyVal.give = legacyData.legacyOptions.find((value) => {
        return value.optionId === 4 && value.selected === true;
      });
      if(endowLegacyVal.give){
        endowLegacyVal.give.successionPlanGranteeOrg = endowLegacyVal.give.successionPlanGranteeOrg && endowLegacyVal.give.successionPlanGranteeOrg.filter((item) =>{
        return item.selected === true;
        } );
        if(!endowLegacyVal.give.successionPlanGranteeOrg){
            endowLegacyVal.give.successionPlanGranteeOrg = [];
        }
    }
    endowLegacyVal.grant = legacyData.legacyOptions.find((value) => {
        return value.optionId === 5 && value.selected === true;
      });
    otherLegacyVal = legacyData.legacyOptions.find((value) => {
        return value.optionId === 6 && value.selected === true;
      });
       legacyModifiedData.bestowLegacy  = bestowLegacyVal;
       legacyModifiedData.endowLegacy   = endowLegacyVal;
       legacyModifiedData.otherLegacy   = otherLegacyVal;
       return legacyModifiedData;
});

export const selectAccountData = state => getMyAccountData(state);

export const selectAdvisorInfo = state => {
    const { data } = getMyAccountData(state);
    return data;
}

export const selectToUpdate = state => {
    const { toUpdate } = getMyAccountStates(state);
    return toUpdate;
};

export const selectToChangeName = state => {
    const { toChangeName } = getMyAccountStates(state);
    return toChangeName;
};

export const selectUpdateDone = state => {
    const { updateDone } = getMyAccountStates(state);
    return updateDone
};

export const selectToChangePrimary = state => {
    const { toChangePrimary } = getMyAccountStates(state);
    return toChangePrimary;
};

export const selectFundName = state => {
    const { defaultFundName } = getMyAccountStates(state);
    return defaultFundName;
};

export const selectIsLoadingAccount = state => {
    const { isLoading } = getMyAccountData(state);    
    return isLoading;
}

export const selectDesignatedUpadteLoader = state => {
    const { designatedUpdateLoader } = getMyAccountData(state);
    return designatedUpdateLoader;
}

export const selectCountryCodeMappingData = state => {
    const { countries } = getMyAccountStates(state);
    return countries;
}



export const selectAdvisorPresentRole = createDeepEqualSelector([getAccountAdvisors], (accountAdvisors) => {

    if(!accountAdvisors) return;

    if(accountAdvisors) {        
        let partyId = JSON.parse(sessionStorage.getItem("userData")).partyId;
        if(!partyId) return;

        let presentInfo = accountAdvisors.filter(i => {
            if(i.partyId === partyId) return i;
        });

        return !presentInfo[0]? 'full': (presentInfo[0].primary ? "primary": 'secondary');
    }
})

export const selectPrimaryContactFullName = createDeepEqualSelector([getPrimaryContacts], (primaryAccountContact) => {     
    if(!primaryAccountContact) return;    
    let primaryInfo = primaryAccountContact.find(i => i.primary === "1");    
    let fullName = primaryInfo && primaryInfo.suffix ? `${primaryInfo.name}, ${primaryInfo.suffix}`: primaryInfo.name;
    return fullName;
})

export const selectActiveVanguardAccounts = createDeepEqualSelector([getAuthorization], authorization => {    
    let vanguardAccts = [];    
    if(authorization && authorization.vanguardAccounts) {
        vanguardAccts = authorization.vanguardAccounts.filter((a) => {
            let receivedDate = moment(new Date(a.receivedDate)).format(
              "MM/DD/YYYY"
            );
            let diffYears = moment().diff(receivedDate, "years", true);
            return isGeminiUser() ? (a && diffYears <= 5) : ((a.accountRegistration === "Private Foundation" || a.accountRegistration == "Other") && diffYears <= 5)            
          });        
    }

    return vanguardAccts;
})

export const selectMyaccountPageTitle = createDeepEqualSelector([getFundNameAndAccountName], (f) => {    
    const { fundName, fundNumber } = f;    
    return `${fundName} (${fundNumber})`;
})

/**---------------------- My Account selectors exports end ----------------------*/

export const myAccountDerivedStates = createStructuredSelector({
    accData: selectAdvisorInfo,
    pageTitle: selectMyaccountPageTitle,
    toUpdate: selectToUpdate,
    toChangeName: selectToChangeName,
    updateDone: selectUpdateDone,
    toChangePrimary: selectToChangePrimary,
    fundName: selectFundName,
    isLoadingAccount: selectIsLoadingAccount,
    accountID: selectAccountID,
    AdditionalAccountDetails: selectAccountRole,
    designatedUpadteLoader: selectDesignatedUpadteLoader,
    CountryCodeMappingData: selectCountryCodeMappingData,
    navBarData: selectNavBarData,
    csrBusinessFunction: selectCsrBusinessFunction,
    accountDocuments: selectAccountDocuments,
    show504Error:isShow504Error,
    editAdvisorRole: selectAdvisorPresentRole,
    primaryContactFullName: selectPrimaryContactFullName,
    vanguardAccts: selectActiveVanguardAccounts,
    legacyData:selectLegacyData    
})

export const myProfileDerivedStates = createStructuredSelector({
    isLoadingProfile:selectIsLoadingProfile,
    toUpdate:selectToUpdate,
    accountID:selectAccountID,
    countries:selectCountryCodeMappingData,
    accessKeyData:selectGetAccessKey,
    accessKeyExpiry:selectValidTill,
    emailInfo:selectEmailInfo
})

export const radioTableDerivedStates = createStructuredSelector({
    accountID:selectAccountID,
    changeDefault:selectChangeDefault
})

export const tableDerivedStates = createStructuredSelector({
    accountID:selectAccountID,
    changeDefault:selectChangeDefault,
    modifiedTableData:selectModifyTableData
})